/**
 * Reporta Web Vitals (LCP, INP, CLS, TTFB, FCP) ao dataLayer do GTM.
 * Sem PII — só métrica, id e rota.
 */
const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then((vitals) => {
      const { onCLS, onINP, onLCP, onFCP, onTTFB, getCLS, getFID, getFCP, getLCP, getTTFB } = vitals;
      // web-vitals v3+ (on*) com fallback v2 (get*)
      if (typeof onCLS === 'function') {
        onCLS(onPerfEntry);
        onINP?.(onPerfEntry);
        onLCP?.(onPerfEntry);
        onFCP?.(onPerfEntry);
        onTTFB?.(onPerfEntry);
      } else if (typeof getCLS === 'function') {
        getCLS(onPerfEntry);
        getFID?.(onPerfEntry);
        getFCP?.(onPerfEntry);
        getLCP?.(onPerfEntry);
        getTTFB?.(onPerfEntry);
      }
    });
  }
};

export default reportWebVitals;
